<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <b-form-input
      :disabled="is_disabled || field_disabled"
      :label="field_label"
      :value="field_value"
      @input="on_input"
      v-bind="field.params"
    ></b-form-input>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";

export default {
  name: "TextWidget",
  components: { FFormGroup },
  mixins: [FormWidgetMixin],
  computed: {
    field_disabled() {
      return this.field.disabled === true;
    },
  },
};
</script>
